import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import { Link, useNavigate, useLocation, useSearchParams } from 'react-router-dom';

function Login() {
    const [searchParams] = useSearchParams();
    const redirectUrl = searchParams.get('redirect');
    const sessionExpired = searchParams.get('expired') === '1';

    // If there's a redirect URL (e.g., from ostercamp), default to member login
    const [loginType, setLoginType] = useState(redirectUrl ? 'member' : 'admin');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const { loginAdmin, loginMember } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    // Get the page they were trying to access
    const from = location.state?.from?.pathname || (loginType === 'admin' ? '/admin' : '/member');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            if (loginType === 'admin') {
                const result = await loginAdmin(username, password);
                // Erstes Login bzw. Force-Rotate: Passwort muss neu gesetzt werden
                if (result.must_change_password) {
                    navigate('/admin/passwort-aendern', { replace: true });
                    return;
                }
                // If there's a redirect URL, go there (for static pages like ostercamp)
                if (redirectUrl) {
                    window.location.href = redirectUrl;
                } else {
                    navigate('/admin', { replace: true });
                }
            } else {
                await loginMember(username, password);
                // If there's a redirect URL, go there (for static pages like ostercamp)
                if (redirectUrl) {
                    window.location.href = redirectUrl;
                } else {
                    navigate('/member', { replace: true });
                }
            }
        } catch (err) {
            setError(err.message);
        }
        setLoading(false);
    };

    return (
        <div className="row justify-content-center">
            <div className="col-md-6 col-lg-4">
                <div className="card mt-5">
                    <div className="card-header">
                        <ul className="nav nav-tabs card-header-tabs">
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${loginType === 'admin' ? 'active' : ''}`}
                                    onClick={() => { setLoginType('admin'); setError(''); }}
                                >
                                    Admin
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${loginType === 'member' ? 'active' : ''}`}
                                    onClick={() => { setLoginType('member'); setError(''); }}
                                >
                                    Mitglied
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div className="card-body">
                        <h4 className="card-title mb-4">
                            {loginType === 'admin' ? 'Admin Login' : 'Mitglieder Login'}
                        </h4>

                        {sessionExpired && (
                            <div className="alert alert-warning">
                                Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.
                            </div>
                        )}

                        {redirectUrl && !sessionExpired && (
                            <div className="alert alert-info">
                                Bitte melde dich an, um auf die Ostercamp-Inhalte zuzugreifen.
                            </div>
                        )}

                        {error && (
                            <div className="alert alert-danger">{error}</div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label">Benutzername</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    required
                                    autoFocus
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Passwort</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                            <button
                                type="submit"
                                className="btn btn-primary w-100"
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Anmelden...
                                    </>
                                ) : (
                                    'Anmelden'
                                )}
                            </button>
                        </form>

                        <div className="text-center mt-3">
                            <Link
                                to={loginType === 'admin' ? '/admin-passwort-vergessen' : '/passwort-vergessen'}
                                className="text-muted small"
                            >
                                Passwort vergessen?
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
